import {useEffect,useRef} from 'react';
import {useLanguage} from '../i18n/LanguageProvider';
export function TechText({text,className='',as:Tag='span',speed=34,delay=0,caret=false}:{text:string;className?:string;as?:'span'|'h2'|'h3'|'p'|'div';speed?:number;delay?:number;caret?:boolean}){
 const {locale}=useLanguage(),host=useRef<HTMLElement>(null);
 useEffect(()=>{
  const el=host.current;
  if(!el||text.length>48||!el.closest('h1,h2')||el.closest('.tf,.ref-invitation')||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  let animation:Animation|undefined;
  const observer=new IntersectionObserver(entries=>{
   if(!entries[0].isIntersecting)return;
   observer.disconnect();
   animation=el.animate([{opacity:.8},{opacity:1}],{duration:Math.min(400,Math.max(150,speed*8)),delay:0});
  },{threshold:.25});
  observer.observe(el);
  return()=>{observer.disconnect();animation?.cancel()};
 },[text,speed,delay,locale]);
 return <Tag ref={host as never} className={'tech-text '+className} aria-label={text}><span aria-hidden="true">{text}</span>{caret&&<i className="tech-caret" aria-hidden="true"/>}</Tag>;
}
